import React, { useState, useEffect } from 'react';
import './DeckHeader.css';

const DeckHeader = ({ activePage, onPageChange }) => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState({
    name: 'User',
    email: 'trial.trial@company.com',
    role: 'Trial',
    avatar: null
  });

  // Telegram channel link
  const telegramChannelUrl = 'https://web.telegram.org/a/#-1003283597491';

  // Page navigation tabs
  const pageTabs = [
    { 





      id: 'arrangement', 
      label: 'Arrangement', 
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M10 4H4a2 2 0 00-2 2v4h8V4zM10 14H4a2 2 0 00-2 2v4h8v-6zM20 4h-6a2 2 0 00-2 2v4h8V4zM20 14h-6a2 2 0 00-2 2v4h8v-6z" strokeWidth="2"/>
        </svg>
      )
    },

    { 
      id: 'insights', 
      label: 'Insights', 
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3" strokeWidth="2"/>
          <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" strokeWidth="2"/>
          <path d="M15 9L21 3" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      )
    },



    { 
      id: 'overview', 
      label: 'Analitics', 
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <rect x="3" y="3" width="7" height="7" rx="1" strokeWidth="2"/>
          <rect x="14" y="3" width="7" height="7" rx="1" strokeWidth="2"/>
          <rect x="3" y="14" width="7" height="7" rx="1" strokeWidth="2"/>
          <rect x="14" y="14" width="7" height="7" rx="1" strokeWidth="2"/>
        </svg>
      )
    },
    { 
      id: 'actions', 
      label: 'Enchanced', 
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="9" strokeWidth="2"/>
          <path d="M12 8V12L15 15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  ];

  const handlePageClick = (pageId) => {
    // Safe function call with null check
    if (typeof onPageChange === 'function') {
      onPageChange(pageId);
    } else {
      console.warn('onPageChange is not a function. Current value:', onPageChange);
    }
  };

  // User account functions
  const handleLogout = () => {
    console.log('Logging out...');
    setUserMenuOpen(false);
  };

  const handleProfile = () => {
    console.log('Opening profile...');
    setUserMenuOpen(false);
  };

  const handleSettings = () => {
    console.log('Opening settings...');
    setUserMenuOpen(false);
  };

  // Close user menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuOpen && !event.target.closest('.user-menu-container')) {
        setUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [userMenuOpen]);

  // Open Telegram channel in new tab
  const openTelegramChannel = () => {
    window.open(telegramChannelUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="deck-header-container">
      <header className="modern-header">
        <div className="header-left">
          <div className="logo-container">
            <div className="logo-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M10 4H4a2 2 0 00-2 2v4h8V4zM10 14H4a2 2 0 00-2 2v4h8v-6zM20 4h-6a2 2 0 00-2 2v4h8V4zM20 14h-6a2 2 0 00-2 2v4h8v-6z" strokeWidth="2"/>
              </svg>
            </div>
            <div className="logo-text">
              <h1>Voyload</h1>
              <span className="app-version">v2.1.0 trial version</span>
            </div>
          </div>
          
          {/* Page Navigation Tabs */}
          <nav className="page-nav">
            {pageTabs.map(tab => (
              <button
                key={tab.id}
                className={`page-tab ${activePage === tab.id ? 'active' : ''}`}
                onClick={() => handlePageClick(tab.id)}
              >
                <span className="tab-icon">{tab.icon}</span>
                <span className="tab-label">{tab.label}</span>
                <div className="tab-indicator"></div>
              </button>
            ))}
          </nav>
        </div>

        <div className="header-right">
          <div className="header-actions">
            {/* Button for notifications panel
            <button className="header-btn" title="Notifications">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" strokeWidth="2"/>
              </svg>
              <span className="notification-badge">3</span>
            </button> */}
            
            {/* Telegram Channel Link */}
            <button 
              className="header-btn" 
              title="Telegram Channel"
              onClick={openTelegramChannel}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                {/* Telegram Logo SVG */}
                <path d="M21.5 2.5L2.5 10.5L8.5 13.5L13.5 21.5L21.5 2.5Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8.5 13.5L21.5 2.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M13.5 21.5L16.5 13.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <div className="user-menu-container">
              <button 
                className="user-profile-btn"
                onClick={() => setUserMenuOpen(!userMenuOpen)}
              >
                <div className="user-avatar">
                  {currentUser.avatar ? (
                    <img src={currentUser.avatar} alt={currentUser.name} />
                  ) : (
                    <div className="avatar-placeholder">
                      {currentUser.name.split(' ').map(n => n[0]).join('')}
                    </div>
                  )}
                </div>
                <div className="user-info">
                  <span className="user-name">{currentUser.name}</span>
                  <span className="user-role">{currentUser.role}</span>
                </div>
                <svg 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor"
                  className={`dropdown-arrow ${userMenuOpen ? 'open' : ''}`}
                >
                  <path d="M6 9l6 6 6-6" strokeWidth="2"/>
                </svg>
              </button>

              {userMenuOpen && (
                <div className="user-dropdown">
                  <div className="dropdown-header">
                    <div className="user-avatar large">
                      {currentUser.avatar ? (
                        <img src={currentUser.avatar} alt={currentUser.name} />
                      ) : (
                        <div className="avatar-placeholder">
                          {currentUser.name.split(' ').map(n => n[0]).join('')}
                        </div>
                      )}
                    </div>
                    <div className="user-details">
                      <h4>{currentUser.name}</h4>
                      <p>{currentUser.email}</p>
                      <span className="user-badge">{currentUser.role}</span>
                    </div>
                  </div>
                  
                  <div className="dropdown-divider"></div>
                  
                  <button className="dropdown-item" onClick={handleProfile}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" strokeWidth="2"/>
                      <circle cx="12" cy="7" r="4" strokeWidth="2"/>
                    </svg>
                    My Profile
                  </button>
                  
                  <button className="dropdown-item" onClick={handleSettings}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <circle cx="12" cy="12" r="3" strokeWidth="2"/>
                      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" strokeWidth="2"/>
                    </svg>
                    Settings
                  </button>
                  
                  <div className="dropdown-divider"></div>
                  
                  <button className="dropdown-item logout" onClick={handleLogout}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" strokeWidth="2"/>
                    </svg>
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default DeckHeader;